// extracted by mini-css-extract-plugin
export default {"form":"Form_form__QLWFo","input-group":"Form_input-group__pFGj+","actions":"Form_actions__yoeu1","button":"Form_button__cxD14","buttonAlt":"Form_buttonAlt__WnMfJ"};